import { createSlice } from "@reduxjs/toolkit";
import { LoginState } from "./types";


export const initialState: LoginState = {
  userData: {
    status: false,
    currentUser: ""
  },
  loading: false,
  error: false,
  signInLoading: false,
  signInError: false,
  putSettingsLoading: false,
  putSettingsError: false,
 
};

export const loginSlice: any = createSlice({
  name: "loginApi",
  initialState,
  reducers: {
    checkLogin: (state) => {
      state.loading = true;
    },
    loginSucess: (state, action) => {
      state.userData = action.payload;
      state.loading = false;
    },
    loginFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    logout: (state) => {
      state.userData = null;
    },
    checkSignUp: (state) => {
      state.signInLoading = true;
    },
    signUpSuccess: (state) => {
      state.signInLoading = false;
    },
    signUpFailed: (state) => {
      state.signInError = true;
      state.signInLoading = false;
    },
    putSettings: (state) => {
      state.putSettingsLoading = true;
    },
    putSettingsSuccess: (state, action) => {
      state.userData = action.payload;
      state.putSettingsLoading = false;
    },
    putSettingsFailed: (state) => {
      state.putSettingsLoading = false;
      state.putSettingsError = true;
    },
  },
});

export const {
  checkLogin,
  loginSucess,
  loginFailed,
  checkSignUp,
  signUpFailed,
  signUpSuccess,
  logout,
  putSettings,
  putSettingsSuccess,
  putSettingsFailed,
} = loginSlice.actions;

export default loginSlice.reducer;
